import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import BackButton from '../../../components/custom/BackButton';
import ActionIcon from '../../../components/custom/ActionIcon';
import FileBase64 from 'react-file-base64';

interface Props {
    modal: boolean;
    setModal: (state: boolean) => void;
    uploadFile: (file) => Promise<void>;
}

export default function UploadModal ({
    modal,
    setModal,
    uploadFile
}: Props) {

    const [file, setFile] = useState();
    
    const toggle = () => setModal(!modal);

    const handleUploadFile = async () => {
        await uploadFile(file);
        toggle();
    }

    useEffect(() => {
        setFile(undefined);
    }, [modal]);

    return (
        <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader className={'d-flex'}>
                <HeaderContainer>
                    <BackButton onClick={toggle} />
                    <h4 className={'pl-2'}>Upload File</h4>
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <FileBase64
                    onDone={setFile}
                />
            </ModalBody>
            <ExpandedFooter>
                <FooterContentContainer>
                    <FooterButtonsContainer>
                        <ActionIcon 
                            type={'save'} 
                            onClick={handleUploadFile} 
                            simulateLoading 
                            disabled={!file}
                        />
                    </FooterButtonsContainer>
                </FooterContentContainer>
            </ExpandedFooter>
        </Modal>
    );
}

const HeaderContainer = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`;

const ExpandedFooter = styled(ModalFooter)`
    width: 100%;
`;

const FooterContentContainer = styled.div`
    width: 100%;
`;

const FooterButtonsContainer = styled.div<{ update?: boolean }>`
    width: 100%;
    display: flex;
    justify-content: ${p => p.update ? 'space-between' : 'flex-end'};
`;